const errors = {
  email: {
    en: 'Enter new e-mail address',
    de: 'Neue E-Mail Adresse eingeben',
  },
  phone: {
    en: 'Enter a valid phone number',
    de: 'Geben Sie eine gültige Rufnummer ein',
  },
  password: 'Passwort muss 8 oder mehr Zeichen haben',
  otp: 'OTP muss 4 stellig sein',
  password_mismatch: 'Passwort passt nicht',
  email_mismatch: {
    de: 'E-Mail stimmt nicht überein',
    en: 'Email mismatch',
  },
  number: 'Wert muss vom Typ Zahl sein',
  positive: 'Wert muss eine positive Zahl sein und größer als 0',
  payment: 'Bitte eine Zahlungsmethode auswählen',
  char_limit: 'Die maximale Zeichenzahl wurde überschritten',
  first_name_min: {
    en: 'First name must be at least 1 character long',
    de: 'Vorname muss mindestens 1 Zeichen lang sein',
  },
  first_name_max: 'Vorname kann max. 100 Zeichen lang sein',
  last_name_min: {
    en: 'Last name must be at least 1 character long',
    de: 'Nachname muss mindestens 1 Zeichen lang sein',
  },
  last_name_max: 'Nachname kann max. 100 Zeichen lang sein',
  name_min: 'Name muss mindestens 1 Zeichen lang sein',
  name_max: 'Name kann max. 100 Zeichen lang sein',
  required: {
    en: 'Required',
    de: 'erforderlich',
  },
  min_cashout_balance_required: {
    en: 'Minimum withdraw balance is required',
    de: 'Mindest Auszahlungsbetrag ist erforderlich',
  },
  exceed_cashout_balance: {
    en: 'Entered amount exceeds your balance',
    de: 'Eingegebener Betrag überschreitet Ihr Guthaben.',
  },
  image: 'Bild auswählen',
  image_size: 'Das Bild muss weniger als 3MB groß sein',
  image_format: 'Bildformat muss jpg, jpeg oder png sein',
  message: {
    de: 'Limit muss vom Typ Zahl sein',
    en: 'Limit must be of type number',
  },
};

export default errors;
